// frontend-react/src/constants/payment.js
// Constantes et helpers pour les paiements

export const PAYMENT_METHODS = [
  { value: 'cash', label: 'Espèces' },
  { value: 'mobile_money', label: 'Mobile Money' },
  { value: 'transfer', label: 'Virement bancaire' },
  { value: 'card', label: 'Carte' },
  { value: 'check', label: 'Chèque' },
];

export const MOBILE_MONEY_PROVIDERS = [
  { value: 'orange_money', label: 'Orange Money' },
  { value: 'moov_money', label: 'Moov Money' },
  { value: 'wave', label: 'Wave' },
  { value: 'mtn_momo', label: 'MTN MoMo' },
  { value: 'other', label: 'Autre' },
];

export function paymentMethodLabel(method) {
  const m = String(method || '').toLowerCase();
  const found = PAYMENT_METHODS.find(x => x.value === m);
  return found ? found.label : (m || '—');
}

export function providerLabel(provider) {
  const p = String(provider || '').toLowerCase();
  const found = MOBILE_MONEY_PROVIDERS.find(x => x.value === p);
  return found ? found.label : (p || '—');
}
